import { render, staticRenderFns } from "./AdjustEdit.vue?vue&type=template&id=8f1027de&scoped=true"
import script from "./AdjustEdit.vue?vue&type=script&lang=js"
export * from "./AdjustEdit.vue?vue&type=script&lang=js"
import style0 from "./AdjustEdit.vue?vue&type=style&index=0&id=8f1027de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1027de",
  null
  
)

export default component.exports